import { Component } from '@angular/core';

@Component({
  selector: 'app-supervisor-step',
  templateUrl: './supervisor-step.component.html',
  styleUrls: ['./supervisor-step.component.scss'],
  standalone: false
})
export class SupervisorStepComponent {
  constructor() { }
}
